import $ from 'jquery'

const SORTING_SELECTOR = '.search-results__sorting-trigger'
const SORTING_WRAPPER_SELECTOR = '.search-results__sorting-wrapper'
const RESULT_ITEM_SELECTOR = '.search-results__result'

class SearchResults {
  constructor() {
    this.sortingToggle = $(SORTING_SELECTOR)
    this.sortingWrapper = $(SORTING_WRAPPER_SELECTOR)
    this.resultItems = $(RESULT_ITEM_SELECTOR)
    this.resultPageVisible = 1
    this.pageSize = 15
    this.init()
  }

  init() {
    this.initEventListener()
    this.updateResultVisibility()
  }

  updateResultVisibility() {
    this.resultItems.slice(0, this.resultPageVisible * this.pageSize).each((i, el) => {
      $(el).removeClass('search-results__result--hidden')
    })
  }

  lastPageRerached() {
    return this.resultPageVisible * this.pageSize >= this.resultItems.length
  }

  lastItemVisible() {
    const lastShownItem = this.resultItems[this.resultPageVisible * this.pageSize - 1]
    return (
      lastShownItem.offsetTop + lastShownItem.offsetHeight <= window.innerHeight + window.scrollY
    )
  }

  initEventListener() {
    this.sortingToggle.on('click', () => {
      this.sortingWrapper.toggleClass('search-results__sorting-wrapper--active')
    })

    $(document).on('scroll', () => {
      if (!this.lastPageRerached() && this.lastItemVisible()) {
        this.resultPageVisible += 1
        this.updateResultVisibility()
      }
    })
  }
}

export default SearchResults
